function checkFrequencyUnit(type) {

}



